export const GET_COURSES = "GET_COURSES";
export const GET_COURSES_SUCCEEDED = "GET_COURSES_SUCCEEDED";
export const GET_COURSES_FAILED = "GET_COURSES_FAILED";
export const GET_COURSE = "GET_COURSE";
export const GET_COURSE_SUCCEEDED = "GET_COURSE_SUCCEEDED";
export const GET_COURSE_FAILED = "GET_COURSE_FAILED";
